import React, { useState, useEffect } from 'react';

const CustomBackgroundPage = ({ apiBaseUrl }) => {
  const [settings, setSettings] = useState({
    imageUrl: '',
    blur: 10,
    opacity: 0.3,
    coverType: 'cover',
  });
  const [customBackground, setCustomBackground] = useState(false);

  useEffect(() => {
    const storedSettings = localStorage.getItem('backgroundSettings');
    if (storedSettings) {
      setSettings(JSON.parse(storedSettings));
    }
    const storedCustomBackground = localStorage.getItem('customBackground');
    setCustomBackground(storedCustomBackground === 'true');
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings((prev) => {
      const newSettings = { ...prev, [name]: name === 'blur' || name === 'opacity' ? parseFloat(value) : value };
      localStorage.setItem('backgroundSettings', JSON.stringify(newSettings));
      return newSettings;
    });
  };

  const handleCustomBackgroundToggle = (e) => {
    const enabled = e.target.checked;
    setCustomBackground(enabled);
    localStorage.setItem('customBackground', enabled.toString());
  };

  return (
    <div className="home-container" style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h1>Background Settings</h1>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <div>
          <label htmlFor="customBackground">Enable Custom Background:</label>
          <input
            type="checkbox"
            id="customBackground"
            checked={customBackground}
            onChange={handleCustomBackgroundToggle}
            style={{ marginLeft: '10px' }}
          />
        </div>
        <div>
          <label htmlFor="imageUrl">Image URL:</label>
          <input
            type="text"
            id="imageUrl"
            name="imageUrl"
            value={settings.imageUrl}
            onChange={handleChange}
            placeholder="Enter image URL"
            style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
            disabled={!customBackground}
          />
        </div>
        <div>
          <label htmlFor="blur">Blur (px):</label>
          <input
            type="number"
            id="blur"
            name="blur"
            value={settings.blur}
            onChange={handleChange}
            min="0"
            max="50"
            step="1"
            style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
            disabled={!customBackground}
          />
        </div>
        <div>
          <label htmlFor="opacity">Opacity (0-1):</label>
          <input
            type="number"
            id="opacity"
            name="opacity"
            value={settings.opacity}
            onChange={handleChange}
            min="0"
            max="1"
            step="0.1"
            style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
            disabled={!customBackground}
          />
        </div>
        <div>
          <label htmlFor="coverType">Cover Type:</label>
          <select
            id="coverType"
            name="coverType"
            value={settings.coverType}
            onChange={handleChange}
            style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
            disabled={!customBackground}
          >
            <option value="cover">Cover</option>
            <option value="fill">Fill</option>
            <option value="tile">Tile</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default CustomBackgroundPage;